// extracted by mini-css-extract-plugin
module.exports = {"container":"RmTable_container__310uP","table":"RmTable_table__1yp5Q"};